import { mediaQuery } from '../utils/media-query';
import { $Qll } from '../utils/query-selector';

const bulletsConfig = (id) => {
  return `#bullets-${id}`;
};

/**
 * Create new slider with arrows
 * @param {String} id - className reference in DOM
 * @param {Boolean} infiniy - prams option, infinity or no
 */
export const configArrows = async (id, perpage = 4) => {
  const { Swiper, Navigation } = await import('swiper');
  // eslint-disable-next-line no-new
  new Swiper(id, {
    modules: [Navigation],
    spaceBetween: 16,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    breakpoints: {
      200: {
        slidesPerView: 1.3,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      720: {
        slidesPerView: perpage,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: perpage,
        spaceBetween: 25,
      },
    },
  });
};

/**
 * Create new slider with pagination
 * @param {String} id - className reference in DOM
 */
export const configPagination = async (id) => {
  const { Swiper, Pagination } = await import('swiper');
  // eslint-disable-next-line no-new
  new Swiper(id, {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: bulletsConfig(id.substr(1)),
      clickable: true,
    },
    breakpoints: {
      200: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      720: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
  });
};

/**
 * Create new slider with arrows and pagination
 * @param {String} id - className reference in DOM
 */
export const configArrowsPagination = async (id) => {
  const { Swiper, Pagination, Autoplay } = await import('swiper');

  const slider = new Swiper(id, {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    pagination: {
      el: bulletsConfig(id.substr(1)),
      clickable: true,
    },
    autoplay: {
      disableOnInteraction: false,
    },
  });
  if (slider.el.dataset.autoplay === 'false') slider.autoplay.stop();
  if (slider.pagination.bullets.length <= 1) {
    slider.pagination.el.style.display = 'none';
  }
};

/**
 * Create new slider with pagination for reviews
 * @param {String} id - className reference in DOM
 */
export const configPaginationReviews = async (id) => {
  const { Swiper, Pagination, Autoplay } = await import('swiper');
  // eslint-disable-next-line no-new
  const slider = new Swiper(id, {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 16,
    pagination: {
      el: bulletsConfig(id.substr(1)),
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 75,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 75,
      },
    },
    autoplay: {
      disableOnInteraction: false,
    },
  });

  if (slider.el.dataset.autoplay === 'false') slider.autoplay.stop();
  if (slider.pagination.bullets.length <= 1) {
    slider.pagination.el.style.display = 'none';

    if (!slider.el.parentElement.classList.contains('notPagination')) {
      slider.el.parentElement.classList.add('notPagination');
    }
  }
};

/**
 * Create new slider with pagination for reviews
 * @param {String} id - className reference in DOM
 */
export const configPaginationSMB = async (id) => {
  const { Swiper, Pagination, Autoplay } = await import('swiper');
  // eslint-disable-next-line no-new
  const slider = new Swiper(id, {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: bulletsConfig(id.substr(1)),
      clickable: true,
    },
  });

  if (slider.pagination.bullets.length <= 1)
    slider.pagination.el.style.display = 'none';
};

const intersectionSlider = (entries, observer) => {
  return entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const { id } = entry.target;
      configArrows(`#${id}`);
      observer.disconnect();
    }
  });
};

/**
 * Iteration to create all sliders with arrows
 */
export const swiperArrows = () => {
  $Qll('.slider_arrows-one').map((slide) => configArrows(`#${slide.id}`, 1));
  $Qll('.slider_arrows-infinity').map((slide) => configArrows(`#${slide.id}`));

  $Qll('.slider_arrows').map((slide) => {
    const options = {
      root: null,
      rootMargin: '0px',
    };
    const observer = new IntersectionObserver(intersectionSlider, options);
    observer.observe(slide);
  });
};

/**
 * Iteration to create all sliders with pagination
 */
export const swiperPagination = () => {
  $Qll('.slider_pagination').map((slide) => {
    const parent = slide.closest('.reviews__slider');
    const parenSMB = slide.closest('.smb-steps-slider');

    if (parent) {
      configPaginationReviews(`#${slide.id}`);
    } else if (parenSMB) {
      mediaQuery('(max-width: 991px)', () => {
        configPaginationSMB(`#${slide.id}`);
      });
    } else {
      configPagination(`#${slide.id}`);
    }
  });
};

export const swiperArrowsPagination = () => {
  $Qll('.slider_arrows_pagination').forEach((slide) => {
    configArrowsPagination(`#${slide.id}`);
  });
};
